<template>
	<div class="groupExamine">
		<div class="filters">
			<!-- 添加输入框和选择框、提交按钮 -->
			<el-form :inline="true">
				<!-- 昵称 -->
				<el-form-item>
					<el-input class="seachInput" v-model="nickName" :placeholder="$t('lang.lbl_duties_note')"></el-input>
				</el-form-item>
				<!-- 电话 -->
				<el-form-item>
					<el-input class="seachInput" v-model="tenantMobile" :placeholder="$t('lang.lbl_duties_mobile')"></el-input>
				</el-form-item>
				<!-- 选择状态 -->
				<el-form-item>
					<el-select class="select" v-model="status" :placeholder="$t('lang.TENANTINFOS.TYPE[0].label')">
						<el-option v-for="item in statuss" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
			</el-form>
			<!-- 添加表格 -->
		</div>
		<el-card>
			<el-table :data="tableData" class="wid100" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
			 :row-class-name="tableRowClassName">
				<el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
				<!-- 姓名 -->
				<el-table-column prop="nickname" :label="$t('lang.lbl_duties_note')"></el-table-column>
				<!-- 电话 -->
				<el-table-column prop="userName" :label="$t('lang.lbl_duties_mobile')"></el-table-column>
        <!-- 拒绝原因 -->
				<el-table-column prop="remark" :label="$t('lang.lab_refReason')"></el-table-column>
				<!-- 操作 -->
				<el-table-column prop="operation" :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width2">
					<template slot-scope="scope">
            <el-button @click="confirm(scope.row)" v-if="(scope.row.isExamine == '' || scope.row.isExamine == 0)">{{$t('lang.btn_cof')}}</el-button>
						<el-button @click="refuse(scope.row)" v-if="(scope.row.isExamine == '' || scope.row.isExamine == 0)">{{$t('lang.btn_refuse')}}</el-button>
            <el-button class="green" @click="alConfirm(scope.row)" v-else-if="(scope.row.isExamine == 1)">{{$t('lang.btn_alcof')}}</el-button>
						<el-button class="orange" @click="alRefuse(scope.row)" v-else-if="(scope.row.isExamine == 2)">{{$t('lang.btn_alRefuse')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
			 :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper" :page-count="pageCount" />
		</el-card>
		<el-dialog :visible.sync="diaIsShow" :close-on-click-modal="false" :title="titleShow" center top="150px" width="500px"
		 @closed="handleDialogClosed">
			<el-form :rules="rules" ref="form" :model="form" :label-width="require('@/config/enum').c_w1">
				<el-form-item prop="name" class="formname">
					<el-input v-model="form.name" :placeholder="$t('lang.lab_pleInputRefReason')"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="diaCancel()">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="diaConfirm('form')">{{$t('lang.btn_confirm')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
/**
 *@ClassName:groupExamine
 *@Description:集团官网注册审批
 *@author:杜斌
 *@Copyright:格众科技
 *@date:2021-08-20
 */

export default {
  name: '/manage/main.groupExamine',
  data() {
    return {
      titleShow: '',
      Id: '',
      isExamine: '',
      content: '',
      diaIsShow: false, // 弹框是否显示
      tableData: [], // 表单数据
      nickName: '', // 昵称
      tenantMobile: '', // 电话
      status: '', // 状态
      statuss: this.$i18n.t('lang.TENANTINFOS.TYPE'), // 可选状态
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      form: {
        name: '',
      },
      rules: {
        name: [
          {
            required: true, message: this.$i18n.t('lang.lab_pleInputRefReason'), trigger: 'blur'
          }
        ],       
      }
    }
  },
  // 初始化
  created() {
    this.topics()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 点击查询
    submit() {
      this.pageNo = 1
      this.topics()
    },  
    // 点击确认
    confirm(row) {
      this.Id = row.id
      this.isExamine = 1
      let loading = this.$loading()
      this.$patch(
        `examine?id=${this.Id}&isExamine=${this.isExamine}`
      ).then(
        res => {
          loading.close()
          console.log(res)
          if (res && res.err == 0) {
            this.pageNo = 1
            this.topics()           
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点击拒绝
    refuse(row) {
      this.titleShow = this.$i18n.t('lang.lab_refReason')
      this.diaIsShow = true
      this.Id = row.id
      this.isExamine = 2
    },
    // 取消拒绝
    diaCancel() {
      this.form.name = ''
      this.$refs.form.clearValidate()
      this.diaIsShow = false
    },
    // 确认拒绝
    diaConfirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let loading = this.$loading()
          let params = {
            id: this.Id,
            isExamine: this.isExamine,
            remark: this.form.name
          }
          this.$patch(`/examine`, params).then(
            res => {
              loading.close()
              console.log(res)
              if (res && res.err == 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.diaIsShow = false
                this.topics()
              }
            },
            error => {
              loading.close()
              this.diaIsShow = false
              this.$message.error(error)
            }
          )         
        }
      })
    },
    // 获取列表
    topics() {
      let loading = this.$loading()
      this.$get(
        `memberList?nickName=${this.nickName}&userName=${this.tenantMobile}&isExamine=${this.status}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
      ).then(
        res => {
          console.log(res)
          loading.close()
          if (res && res.err === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
            console.log(this.tableData)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.diaCancel()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.topics()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.topics()
    }
  }
}
</script>

<style lang='scss'>
	.groupExamine {
		.img {
			width: 80px;
			height: 50px;
			border: 1px solid lightgray;
			border-radius: 5px;
			padding: 5px;
		}

		.img-width {
			overflow: hidden !important;
			text-overflow: ellipsis !important;
			white-space: nowrap !important;
			max-width: 320px;
		}

		.formname {
			text-align: center;
			width: 400px;
		}

		.green {
			color: #008000;
		}
	}
</style>
